import Vue from 'vue'
import Vuex from 'vuex'

import { message } from './message.module'
import { alert } from './alert.module'
import { authentication } from './authentication.module'
import { event } from './event.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    alert,
    authentication,
    event,
    message

  }
})
